
export const GUEST_FLOW_ERROR_CODE = {
    "LINK_EXPIRED" : "LINK_EXPIRED"
}

export const SPECIAL_ERRORS = {
    "GET_STATIC_DATA_FAILED" : "GET_STATIC_DATA_FAILED",
    "GET_DYNAMIC_DATA_FAILED" : "GET_DYNAMIC_DATA_FAILED",
    "RESTAURANT_CLOSED" : "RESTAURANT_CLOSED",
    "RESTAURANT_UNDER_MAINTENANCE" : "RESTAURANT_UNDER_MAINTENANCE",
    "RESTAURANT_MENU_NOT_ACTIVE_TODAY" : "RESTAURANT_MENU_NOT_ACTIVE_TODAY",
    "NETWORK_ERROR" : "NETWORK_ERROR"
}
